<template>
  <div>
      <Navbar></Navbar>
      <mdb-container class="main-container d-flex flex-row justify-content-start authenticated-router-view-contaner">
          <router-view />
      </mdb-container>
      <CartModal ref="cartModal"></CartModal>
      <ScanModal ref="scanModal"></ScanModal>

      <ValidationObserver class="needs-validation form-custom-format" tag="form" ref="customerObserver"  v-slot="{passes}" @submit.prevent="onValidateCustomerForm()">    
        <mdb-modal :show="showModal" @close="showModal = false" class="modal" centered>
                <mdb-modal-header>SEND TO EMAIL</mdb-modal-header>
                <mdb-modal-body>
                    <TextInput tabindex="2" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="Email" vid="email" name="email" v-model="emailForm.email" size="sm" :disabled="false" :rules="'required'"/>
                </mdb-modal-body>
                <mdb-modal-footer>
                <template v-if="sendEmailLoading">
                    <mdb-btn color="elegant" size="sm" class="mt-2 z-depth-0">
                    <span class="spinner-border spinner-border-sm " role="status" aria-hidden="true"></span>
                    Please wait...
                    </mdb-btn>
                </template>
                <template v-else>
                    <mdb-btn color="elegant" size="sm" class="mt-2 z-depth-0" @click.native="passes(onSubmitEmailForm)">Send Email</mdb-btn>  
                </template>
                    <mdb-btn @click="closeModal" color="elegant" class="mt-2 z-depth-0" size="sm">Close</mdb-btn>
                </mdb-modal-footer>
            </mdb-modal>
        </ValidationObserver>
  </div>
</template>
<script>
import Navbar from '../components/Navbar'
import {mdbContainer, mdbModal, mdbModalHeader, mdbModalBody, mdbModalFooter,mdbBtn} from 'mdbvue'
import {mapActions, mapGetters} from 'vuex'
import CartModal from "../components/CartModal"
import ScanModal from "../components/ScanModal"
import {TextInput} from '../components/common'
import { ValidationObserver,ValidationProvider } from "vee-validate";
export default {
    name: 'Authenticated',
    components : {
      Navbar,
      mdbContainer,
      mdbModal, mdbModalHeader, mdbModalBody, mdbModalFooter,
      mdbBtn,
      CartModal,
      ScanModal,
      TextInput,
      ValidationObserver,ValidationProvider
    },
    data(){
        return {
            showModal : false,
            emailForm : {
                email : ''
            },
            sendEmailLoading : false
        }
    },
    mounted(){
        const self = this;
        console.log("this.cartData",this.cartData)
        if(this.cartData == null || this.cartData.length == 0){
            this.createCart();
            console.log("created cart");
        }

        this.getCart();

        this.$eventBus.$on('open-cart', function(){

            console.log("self.$refs.cartModal",self.$refs.cartModal)
            self.$refs.cartModal.openModal();
        })

        this.$eventBus.$on('open-scan', function(){

            self.$refs.scanModal.openModal();
        })
        this.$eventBus.$on('send-to-email', function(){
            self.showModal = true;
        })
    },
    methods : {
        ...mapActions('CartModule',[
            'getCart',
            'getCartData',
            'createCart',
        ]),
        
        ...mapActions('ProductModule',[
            'sendEmailData'
        ]),

        openNotification(){

        },
        closeModal(){
            this.showModal = false;
        },
        onSubmitEmailForm(){
            
            const success = this.$refs.customerObserver.validate();
            if(!success) return;

            if(success){
                this.sendEmailLoading = true;
                this.sendEmailData({...this.emailForm, cartKey : this.cartData.cartKey}).then((res) => {
                    this.showModal = false;
                    this.$ThatsNotify.success({message : "Email has been sent"});
                    console.log(res);
                    this.sendEmailLoading = false;
                });
            }
        }
    },

  
    computed : {
        ...mapGetters('CartModule',[
            'cartData',
        ])
    }
    
}
</script>
<style scope lang="scss">
</style>